<template>
  <div class="d-content">
      <dashboard-content-nav :nav="navItems" v-if="!ifHr && !ifEmployee && !ifAuditor"/>
      <keep-alive>
          <component :is="currentComponent" :entity_index="entity_index"></component>
      </keep-alive>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";

import dashboardContentNav from "@/components/dashboard/contentNav.vue";
//Pages
import payrollDashboard from "./payrollDashboard.vue";
import monthlypayroll from "./monthlyPayroll/monthlyPayroll.vue";
import monthlypayrollNew from "./monthlyPayroll/monthlyPayrollNew.vue";
import compliance from "./compliance.vue";
import fbp from "./monthlyPayroll/fbp.vue";
import fbpPayroll from "./fbp.vue";
import installments from "./installation.vue"
import taxOutside from "./taxOutside.vue" 
import providentFund from "./pf.vue";
import employeeProfile from "./employeeProfile.vue";
import mySalary from "./mySalary.vue";
import incometax from "./incometax/incometax.vue";
// import jvreports from "./reports/jvReports.vue";

// import utilities from "./utilities.vue";
import utilities from "./utilities/utility.vue"
import legacy_salary_data from "./utilities/legacy_salary_Data.vue";
import leaves_attendance from "./utilities/leaves_Attendence_Data.vue";
import upload_lop_rlop from "./utilities/lopandrlop/uploadLopRlopIntro.vue";
import add_exit_employees from "./utilities/addexitemployees/addexitemployeesInitial.vue";
import assign_fbp_components from "./utilities/assignfbpcomponents/AssignFBPComponents.vue";
import settle_fbp_claims from "./utilities/settlefbpclaims/SettleFbpClaims.vue"
import hold_release_salary from "./utilities/holdReleaseSalary/holdReleaseSalary.vue";
import statutory_deduction from "./utilities/statutorydeduction/statutoryDeduction.vue";
import monthlyPaygroups from "./manage-paygroups/payGroup_Intro.vue";
import paygroupDetails from "./manage-paygroups/crud_PayGroup.vue";
import addPayGroup from "./manage-paygroups/addNew_PayGroup.vue";
import incometaxdeclarationdashboard from "./incometax/incomeTaxDeclarationDashboard.vue";
import incometaxdeclarationplan from "./incometax/incomeTaxDeclarationPlan.vue";



//  import monthlyPaygroups from "./manage-paygroups/payGroup_Intro.vue";
//  import paygroupDetails from "./manage-paygroups/crud_PayGroup.vue";
//  import addPayGroup from "./manage-paygroups/addNew_PayGroup.vue";
import revise_salary from "./utilities/revisesalary/reviseSalaryInitial.vue";
import fbp_claim_bills from "./utilities/fbpClaimBills/fbpClaimBills.vue";
// import itReports from "./reports/ITReports.vue";
import statutory_bonus from "./utilities/statutorybonus/StutoryBonus.vue"
// import itReports from "./reports/ITReports.vue";
// import itReports from "./reports/ITReports.vue";
// import incrementArrearsReports from "./reports/incrementArrearsReports.vue";
// import loanReports from "./reports/loanReports.vue";
// import profileReports from "./reports/profileReports.vue";
//import assignFixedNonCTCcomponents from "./assignFixedNonCTCcomponents/assignFixedNonCTCcomponents.vue"


import holdSalary from "./utilities/holdReleaseSalary/holdSalary.vue";
import stopSalary from "./utilities/holdReleaseSalary/stopSalary";
import activeSalary from "./utilities/holdReleaseSalary/activeSalary.vue";

import incometaxProof from "./incometaxProof/incometaxProof.vue";
import incometaxproofplan from "./incometaxProof/incomeTaxProofPlan.vue";
import incometaxproofformplan from "./incometaxProof/incomeTaxProofFormPlan.vue";
import incometaxproofapproval from "./incometaxProofApproval/incometaxProofApproval.vue";
import incometaxaudit from "./itProofAuditing/itProofSubmissionApproval.vue"
import investmentProofs from "./incometaxProofApproval/investmentProofs.vue";
import addNewClaim from "./utilities/addNewClaim/addNewClaim.vue";
import addNewClaimFbpComponent from "./utilities/addNewClaim/addNewClaimFbpComponent.vue";
import approveFbpClaims from "./utilities/approveFbpClaims/approveFbpClaims.vue";
import editFbpClaims from "./utilities/approveFbpClaims/editFbpClaims.vue";

import fbpProcessMonth from "./utilities/fbpProcessMonth/fbpProcessMonth.vue";
import pushFbpConfiguration from "./utilities/pushFbpConfiguration/pushFbpConfiguration.vue";
import fbpLock from "./utilities/fbpLock/fbpMain.vue"
import fbpDeclaration from "../HumanResources/declaration.vue";
import perquisites from "./perquisites/perquisitesMapEmployee.vue";
import fbpProcessUnClaimed from "./utilities/fbpProcessMonth/fbpProcessUnClaimed.vue";
import fbpReportDownload from "./utilities/fbpProcessMonth/fbpReportDownload.vue";
import uploadPayslipItsheet from "./utilities/uploadPayslipItsheet"
import uploadForm16AndGeneral from "./utilities/uploadForm16General"
import releaseCompensationESS from "./utilities/releaseCompensationESS"
import payrollReports from "./utilities/payrollReports/payrollReports.vue"

const mapNameToComponents = {
"monthlypayroll": monthlypayrollNew,
 "monthlypayroll1":monthlypayrollNew,
"payrollDashboard":payrollDashboard,
"compliance" :compliance,
"fbp": fbp,
"providentFund":providentFund,
"employeeProfile": employeeProfile,
"mySalary": mySalary,
"fbpPayroll":fbpPayroll,
"installments":installments,
"taxOutside":taxOutside,
"incometax":incometax,
"utilities" :utilities,
"monthlyPaygroups" :monthlyPaygroups,
"paygroupDetails" : paygroupDetails,
"addPayGroup":addPayGroup,
// "jvreports": jvreports,
// "itReports":itReports,
// "increment_arrears_Reports":incrementArrearsReports,
// "loanreports":loanReports,
// "profilereports":profileReports,
"legacy_salary_data" :legacy_salary_data,
"leaves_attendance" :leaves_attendance,
"hold_release_salary":hold_release_salary,
"statutory_deduction": statutory_deduction,
"override_deduction" : () => import('./utilities/statutorydeduction/overrideDeductions.vue'),
"upload_lop_rlop" :upload_lop_rlop,
"editEmployeeLop" : () => import('./utilities/lopandrlop/editEmployeeLop.vue'),
"add_exit_employees": add_exit_employees,
"assign_fbp_components":assign_fbp_components,
"settle_fbp_claims": settle_fbp_claims,
"revise_salary": revise_salary,
"fbp_claim":fbp_claim_bills,
"incometaxdeclarationdashboard":incometaxdeclarationdashboard,
//"modifyFbpBand": () => import('./reports/ITReports.vue'),
"increment_arrears": () => import('./utilities/increment-arrears/increment-arrears.vue'),
"override_increment": () => import('./utilities/increment-arrears/override-arrears.vue'),
"release_salary": ()=> import('./utilities/holdReleaseSalary/ReleaseSalary.vue'),
"fbpClaims": ()=> import('./utilities/fbpClaimsByAdmin/fbpClaims.vue'),
"newfbpclaim": ()=> import('./utilities/fbpClaimsByAdmin/newFbpClaim.vue'),
"statutory_bonus":statutory_bonus,
"delete_payroll_data": () => import("./utilities/deletepayrolldata/DeletePayrollData.vue"),
"form16": () => import("./utilities/form16/form16.vue"),
"assignFixedNonCtcComponents": ()=> import('./utilities/assignFixedNonCTCcomponents/assignFixedNonCTCcomponents.vue'),
//"updateFixedNonCtcComponents": ()=> import('./utilities/assignFixedNonCTCcomponents/assignNonCTCcomponentsToEmployees.vue'),
"updateFixedNonCtcComponents": ()=> import('./utilities/assignFixedNonCTCcomponents/nonCtcComponents.vue'),
"componentsLog": ()=> import('./utilities/assignFixedNonCTCcomponents/componentsLog.vue'),
"componentHistory": ()=> import('./utilities/assignFixedNonCTCcomponents/nonCtcComponentHistory.vue'),
"advanceSettings": ()=> import('./utilities/assignFixedNonCTCcomponents/advanceSettings.vue'),
"manageRoles": ()=> import('./utilities/manageRoles/manageRoles.vue'),
"holdSalary": holdSalary,
"stopSalary": stopSalary,
"activeSalary": activeSalary,
"incometaxdeclarationplan": incometaxdeclarationplan,

"incometaxProof": incometaxProof,
"incometaxproofplan": incometaxproofplan,
"incometaxproofformplan": incometaxproofformplan,
"incometaxproofapproval": incometaxproofapproval,
"incometaxaudit":incometaxaudit,
"investmentProofs" : investmentProofs,
"fbpProcessMonth": fbpProcessMonth,
"addNewClaim": addNewClaim,
"addNewClaimFbpComponent": addNewClaimFbpComponent,
"approveFbpClaims": approveFbpClaims,
"editFbpClaims":editFbpClaims,
"pushFbpConfiguration": pushFbpConfiguration,
"fbpLock": fbpLock,
"fbpDeclaration" : fbpDeclaration,
"perquisites": perquisites,
"fbpProcessUnClaimed": fbpProcessUnClaimed,
"fbpReportDownload": fbpReportDownload,
"uploadPayslipItsheet": uploadPayslipItsheet,
"uploadForm16AndGeneral": uploadForm16AndGeneral,
"releaseCompensationESS": releaseCompensationESS,
"payrollReports" : payrollReports,
}

const getPathForStep = (entity_index, step_name, sub_step, sub_step_name) => {
if (sub_step_name) {
  return `/dashboard/${entity_index}/${step_name}/${sub_step}/${sub_step_name}`
}
else {
  return `/dashboard/${entity_index}/${step_name}/${sub_step}`
}
}



const nav_items = (entity_index) =>([

    // {
    //   type: "navitem",
    //   label: "Monthly Payroll",
    //   path: getPathForStep(entity_index,'monthlypayroll'),
    //   icon : "organisation",
    // },
    // {
    //   type: "navitem",
    //   label: "Compliance",
    //   path: getPathForStep(entity_index,'compliance'),
    //   icon : "organisation"
    // },
    // {
    //   type: "navitem",
    //   label: "Reports",
    //   path: getPathForStep(entity_index,'reports'),
    //   children: [{
    //     path: getPathForStep(entity_index,'reports','jvreports')
    //   },
    //   {
    //     path: getPathForStep(entity_index,'reports','salary_reports')
    //   },
    //   {
    //     path: getPathForStep(entity_index,'reports','salary_register')
    //   },{
    //     path: getPathForStep(entity_index,'reports','increment_arrears_Reports')
    //   },{
    //     path: getPathForStep(entity_index,'reports','loanreports')
    //   },{
    //     path: getPathForStep(entity_index,'reports','profilereports')
    //   }, {
    //     path: getPathForStep(entity_index,'reports','payrollreport')
    //   }
    //   ],
    //   icon : "reports"
    // },
     {
      type: "navitem",
      label: "Payroll Dashboard",
      path: getPathForStep(entity_index,'payroll','monthlypayroll'),
      icon : "icon-payDash",
      dropdown_icon: false,
      sub_nav: false
    },
    // {
    //   type: "navitem",
    //   label: "New Payroll Dashboard",
    //   path: getPathForStep(entity_index,'payroll','monthlypayroll1'),
    //   icon : "icon-payDash",
    //   dropdown_icon: false,
    //   sub_nav: false
    // },
    // {
    //   type: "navitem",
    //   label: "New Payroll Dashboard",
    //   path: getPathForStep(entity_index,'payroll','monthlypayroll1'),
    //   icon : "icon-payDash",
    //   dropdown_icon: false,
    //   sub_nav: false
    // },
    
    {
      type: "navitem",
      label: "FBP",
      path: `/dashboard/${entity_index}/payroll/fbpPayroll`,
      icon : "icon-fbp",
      dropdown_icon: false,
      sub_nav: false
    },{
      type: "navitem",
      label: "Income Tax",
      path: getPathForStep(entity_index,'payroll','incometax'),
      icon : "icon-incometax",
      dropdown_icon: true,
      sub_nav: true,
      isHover: false,
      sub_item: [
        {
          label: "IT Declarations",
          path: getPathForStep(entity_index,'payroll','payroll','incometax'),
        },
        {
          label: "IT Proof Submission",
          path: getPathForStep(entity_index,'payroll','payroll','incometaxProof'),
        },
        {
          label: "IT Proof Approval",
          path: getPathForStep(entity_index,'payroll','payroll','incometaxproofapproval'),
        },
        // {
        //   label: "IT Proof Audit",
        //   path: getPathForStep(entity_index,'payroll','incometaxaudit'),
        // }
      ]
    },
    // {
    //   type: "navitem",
    //   label: "IT Proof Submission",
    //   path: getPathForStep(entity_index,'incometaxProof'),
    //   icon : "icon-incometaxProof",
    //   dropdown_icon: false,
    //   sub_nav: false
    // },
    // {
    //   type: "navitem",
    //   label: "Provident Fund",
    //   path: getPathForStep(entity_index,'providentFund'),
    //   icon : "icon-pf",
    //   dropdown_icon: false,
    //   sub_nav: false
    // },
    // {
    //   type: "navitem",
    //   label: "Myself",
    //   path: getPathForStep(entity_index,'employeeProfile'),
    //   icon : "icon-pf",
    //   dropdown_icon: false,
    //   sub_nav: false
    // },
    // {
    //   type: "navitem",
    //   label: "My Salary",
    //   path: getPathForStep(entity_index,'mySalary'),
    //   icon : "icon-pf",
    //   dropdown_icon: false,
    //   sub_nav: false
    // },
    {
      type: "navitem",
      label: "Payroll Utilities",
      path: getPathForStep(entity_index,'payroll','utilities'),
      icon : "icon-utilities",
      sub_nav: false,
      dropdown_icon: false,
      children:[{
        path: getPathForStep(entity_index,'payroll','utilities','leaves_attendance'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','upload_lop_rlop'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','add_exit_employees'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','assign_fbp_components'),
      },{
        path: getPathForStep(entity_index,'payroll','utilities','settle_fbp_claims'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','fbp_claim'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','statutory_bonus'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','statutory_deduction'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','delete_payroll_data')
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','newfbpclaim'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','assignFixedNonCtcComponents'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','updateFixedNonCtcComponents'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','fbpProcessMonth'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','addNewClaim'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','approveFbpClaims'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','pushFbpConfiguration'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','fbpLock'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','fbpDeclaration'),
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','fbpProcessUnClaimed')
      },
      {
        path: getPathForStep(entity_index,'payroll','utilities','fbpReportDownload')
      },
      {
        path: getPathForStep(entity_index,'utilities','fbpReportDownload')
      },
      {
        path: getPathForStep(entity_index,'utilities','uploadPayslipItsheet')
      },
      {
        path: getPathForStep(entity_index,'utilities','releaseCompensationESS')
      },
      {
        path: getPathForStep(entity_index,'utilities','uploadForm16AndGeneral')
      },
      {
          path: getPathForStep(entity_index,'utilities','payrollReports')
      }
      
      // {
      //   path: getPathForStep(entity_index,'utilities','componentHistory'),
      // },
      // {
      //   path: getPathForStep(entity_index,'utilities','advanceSettings'),
      // },

      ]
      // icon : "settings-1"
    },
    {
      type: "navitem",
      label: "Perquisites",
      path: getPathForStep(entity_index,'payroll','perquisites'),
      icon : "icon-fbp",
      dropdown_icon: false,
      sub_nav: false
    },
    {
      type: "navitem",
      label: "Installments",
      path: getPathForStep(entity_index,'payroll','installments'),
      icon : "id-installments",
      dropdown_icon: false,
      sub_nav: false
    },
    {
      type: "navitem",
      label: "Tax Outside",
      path: getPathForStep(entity_index,'taxOutside'),
      icon : "id-taxOutsides",
      dropdown_icon: false,
      sub_nav: false
    }
]);


export default {
components : {
    dashboardContentNav
},
props: ['step_name', 'sub_step', 'sub_step_name', 'entity_index'],
data() {
  return {
    navItems: [],
    enable_legal_entity: ['5d5eadf5-3ec0-4ca1-9c9e-507be4e948f5', '3105819a-49a9-4d8d-a1c2-66da4106847b', '71f9f360-5ccd-45b7-924b-9be3b3b4f674', '37a3f642-1cac-487e-8628-83324e9b1623','28c6533e-cce0-404b-a7cb-9a20512ebf36'],
  }
},
mounted() {
  this.updateNavItems()
},
methods: {
  contentShow(event) {
    var sections = document.querySelectorAll('.d-payroll__accordBlock');
    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.remove('active');
    }
    event.target.parentNode.classList.toggle("active");
  },
  // updateNavItems() {
  //   if(this.ifAuditor) {
  //     this.navItems = [];
  //   }
  // }
  updateNavItems() {
      if(this.ifAuditor) {
      this.navItems = [];
    }
    const defaultNavItems = nav_items(this.entity_index);
    console.log('Default nav items:', defaultNavItems);
    const leId = this.le_id;

    // if (this.enable_legal_entity.includes(leId)) {
    //   this.navItems =  this.navItems.push({
    //   type: "navitem",
    //   label: "New Payroll Dashboard",
    //   path: getPathForStep(this.entity_index, 'payroll', 'monthlypayroll1'),
    //   icon: "icon-payDash",
    //   dropdown_icon: false,
    //   sub_nav: false,
    // });
    // } else {
    //   this.navItems = defaultNavItems.filter(item => item.label !== "New Payroll Dashboard");
    // }
    console.log('Filtered nav items:', this.navItems);
  }
},

created() {

     this.navItems = nav_items(this.entity_index);
     //console.log(this.entity_index);

},
computed: {
  ...mapGetters({
    getleid: "onboard/legal_entities/legal_entity_ID"
  }),

  ...mapState({
    userRoleState: (state) => state.auth.role
  }),

  currentComponent: function () {
    if (this.sub_step_name) {
      return mapNameToComponents[this.sub_step_name];
    } else {
      return mapNameToComponents[this.sub_step];
    }
  },
  le_id() {
    if (this.$route.params.entity_index)
      return this.getleid(this.$route.params.entity_index);
    else return this.getleid(0);
  },
  ifHr() {
    return this.userRoleState == "HR" ? true : false;
  },
  ifEmployee() {
    return this.userRoleState == "EMPLOYEE" ? true : false;
  },
  ifAuditor() {
    return this.userRoleState == "AUDITOR" ? true : false;
  }
}
}
</script>
<style lang="scss" scoped>
@import '@/scss/dashboard/_variables.scss'; // Common
@import '@/scss/dashboard/content/_section.scss'; // Content Section
</style>
